export const CREATE_REFERRAL_TYPE = 'EMPLOYEE_CLIENT_REFERRAL';

/** Matches Insights ReferClientForm property type options. */
export const PROPERTY_TYPE_OPTIONS = [
  { id: 'parking_slot', name: 'Parking Slot' },
  { id: 'hardware', name: 'Hardware' },
  { id: 'manpower', name: 'Manpower' },
];

export const INITIAL_FORM_VALUES = {
  name: '',
  phone_number: '',
  email_id: '',
  property_name: '',
  property_type: null,
  remark: '',
};
